import type { App } from 'vue'
import { Icon } from './Icon'
import { Card } from './Card'
import { Button } from './Button'
import { Dialog } from './Dialog'
import { Pagination } from './Pagination'
import { CTooltip } from './CTooltip'
import { RichTextEditor } from './RichTextEditor'
export const setupGlobCom = (app: App<Element>): void => {
  app.component('Icon', Icon)
  app.component('Card', Card)
  app.component('Button', Button)
  app.component('Dialog', Dialog)
  app.component('Pagination', Pagination)
  app.component('CTooltip', CTooltip)
  app.component('RichTextEditor', RichTextEditor)
}
